export default [
  { name: 'Male', value: 'Male' },
  { name: 'Female', value: 'Female' },
]
